import styled from 'styled-components';
import addAlpha from 'utils/addAlpha';
import { Overline } from 'components/Typography';
import DefaultRow from './Row';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow:
    0rem 0.5rem 1rem rgba(35, 35, 35, 0.02),
    0rem 0.5rem 2rem rgba(35, 35, 35, 0.02);
  border-radius: 1.5rem;
  margin-bottom: 2rem;
`;

export const Header = styled.header`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 10rem 6.5rem;
  height: 3rem;
  padding: 1.375rem 2rem 0.3125rem 2rem;

  > *:nth-child(5) {
    justify-self: flex-end;
  }
`;

export const Row = styled(DefaultRow)``;

export const Caption = styled(Overline)`
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.6)};
  letter-spacing: 0.1em;
  font-weight: 600;
`;
